import angular from 'angular';
import moment from 'moment';

angular
  .module('cxSettings')
  .controller('UpdateRegistrationsInternalPriceDialogCtrl', [
    '$element',
    '$scope',
    'close',
    '$window',
    'internalPrice',
    'flySvc',
    updateRegistrationsInternalPriceDialogCtrl,
  ]);

function updateRegistrationsInternalPriceDialogCtrl(
  $element,
  $scope,
  close,
  $window,
  internalPrice,
  flySvc,
) {
  var vm = this;
  vm.model = {
    internalPrice,
    updateRegistrations: false,
    startDate: moment()
      .utc()
      .startOf('day')
      .toDate(),
    endDate: moment()
      .utc()
      .startOf('day')
      .toDate(),
  };

  vm.submit = function() {
    if (vm.model.updateRegistrations && (!vm.model.startDate || !vm.model.endDate)) {
      flySvc.error('msgStartEndDateRequiredUpdateInternalPrice');
      return;
    }

    // The UTC datepickers stay bound until the modal closes and only accept Dates.
    const result = { ...vm.model };
    if (result.updateRegistrations) {
      result.startDate = moment.utc(result.startDate);
      result.endDate = moment.utc(result.endDate);
    }

    $element.modal('hide');
    close(result, 500);
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
